import * as React from 'react';
import {
    useEffect,
    useState
} from 'react';
import {
    useSelector,
    useDispatch
} from 'react-redux';

import {
    Button,
    Badge,
    Collapse,
    Input,
    Pagination,
    Tabs,
} from 'antd/lib'; 

import { 
    CardErrorMsg,
    CardLockIcon
} from 'one-card-notification';
import notification from 'antd/lib/notification';
import { CardNoData } from 'one-ui-card';

import { useCtx } from "one-ui-provider";


import './style.less';

const { TextArea } = Input;
const { Panel } = Collapse;

/**
 * This function returns all the notes history
 * @param props has all input parameters to load the Card
 * @returns JSX code for notes history
 */
export const NotesHistoryCard = () => {
    const [newNote, setNewNote] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageNotes, setCurrentPageNotes] = useState([]);
    const [activePanel, setActivePanel] = useState(null);

    const dispatch = useDispatch();
    const patients = useSelector((state: any) => (state.selectedsubjectinfo));
    const notesHistory = useSelector((state: any) => (state.notesHistory));
    const {  settings } = useCtx();
    const { uisettings: { agent_notes: { display: cardDisplay, maxNotesToDisplay } } } = settings;

    useEffect(() => {
        if (notesHistory?.notes?.length > 0) {
            let start = (currentPage - 1) * maxNotesToDisplay;
            let end = start + maxNotesToDisplay;
            setCurrentPageNotes(notesHistory.notes.slice(start, end));
        }
    }, [notesHistory?.notes]);
    
    useEffect(() => {
        if (notesHistory?.status === 200) {
          notification.config({
            placement: "topRight",
            top: 400,
            duration: 3
          });
          notification['success']({
            message: 'Notes saved successfully.',
            description: "",
          });
        }
        if (notesHistory?.status === 400) {
          notification.config({
            placement: "topRight",
            top: 400,
            duration: 3
          });
          notification['error']({
            message: 'Failed to save note.',
            description: "",
          });
        }
        dispatch({
            type: 'one-state-notes-history/setStatus',
            payload: 0
        });
      }, [notesHistory?.status]);
    const handleClickAddNote = () => {
        dispatch({
            type: 'notes-history--add',
            payload: {
                patientId: patients?.id,
                note: newNote
            }
        });
        setNewNote('');
    };

    const onChange = (page: any) => {
        setCurrentPage(page);
        let start = (page - 1) * maxNotesToDisplay;
        let end = start + maxNotesToDisplay;
        setCurrentPageNotes(notesHistory.notes.slice(start,  end));
        setActivePanel(null);
    };

    if (!cardDisplay) {
        return (
            <div className="notes-history">
                <div className="notes-history--header">
                    <p className="title">Notes History</p>
                </div>
                <div className="notes-history--lock">
                    <CardLockIcon />
                </div>
            </div>
        );
    }

    let addNoteBody = (
        <div className='notes-history--add-note'>
            <TextArea 
                rows={2} 
                value={newNote}
                style={{ height: "100px" }}
                onChange={e => setNewNote(e.target.value)}
            />
           
            <div className='opt-crm'>
               
                <Button 
                    type="primary" 
                    style={{marginTop: '10px'}}
                    onClick={handleClickAddNote}
                    disabled={newNote.trim().length === 0}
                >
                    Save
                </Button>
            </div>
        </div>
    );

    let notesHistoryBody;
    if (notesHistory?.notes?.length > 0) {
                notesHistoryBody = (
            <div className='notes-history--notes-view'>
                <div className='notes-history--notes-view-accordion'>
                    <Collapse 
                        accordion 
                        activeKey={activePanel}
                        onChange={(key) => setActivePanel(key)}
                    >
                        {currentPageNotes?.map((item: any, index: any) => {
   let panelHeader = (
    <div className='panel-header'>
        <div>{item.agentId} | {item.date} | {item.time}</div>
        {item.isEpic && (
            <div>Stored in Epic</div>
        )}
    </div>
)
return (
    <Panel 
        header={panelHeader}
        key={index}
    >                    
                <p>{item.note}</p>
                            </Panel>
)
})}
                    </Collapse>
                </div>
                <Pagination
                    current={currentPage} 
                    pageSize={maxNotesToDisplay} 
                    total={notesHistory.notes.length} 
                    onChange={onChange} 
                    size='small'
                />
            </div>
        )
    } else {
        notesHistoryBody = <CardNoData />
    }

    if (notesHistory.error && notesHistory?.notes?.length === 0) {
        notesHistoryBody = (
            <div 
                className='notes-history--notes-view'
                style={{textAlign: 'center'}}
            >
                <CardErrorMsg />   
            </div>
        )
    }

    return (
        <Tabs defaultActiveKey='1' className='notes-history'>
            <Tabs.TabPane tab='Add a note...' key='1'>
                {addNoteBody}
            </Tabs.TabPane>
            <Tabs.TabPane 
                tab={
                    <Badge count={notesHistory?.notes?.length} overflowCount={999}>
                        Notes History
                    </Badge>
                }
                key='2'
            >              
              {notesHistoryBody}
            </Tabs.TabPane>
        </Tabs>
    );
};
